<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-card text>
        <v-col cols="12">
          <h1 class="ml-3 mt-2">Persuasion</h1>
          <goals-calculation-block
            :metrics="persuasion"
            @updateMetric="updatePersuasionMetric"
          />
        </v-col>
        <v-col cols="12">
          <v-card color="grey lighten-4" text tile>
            <h1 class="ml-3 pt-4">GOTV</h1>
            <goals-calculation-block
              :metrics="gotv"
              @updateMetric="updateGotvMetric"
            />
          </v-card>
        </v-col>
      </v-card>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import lodash from 'lodash'
  import helpers from '../../helpers/functions'
  import GoalsCalculationBlock from './GoalsCalculationBlock.vue'
  export default {
    name: 'goals',
    components: {
      GoalsCalculationBlock
    },
    data () {
      return {
        persuasion: {
          cpm: 10,
          ctr: 1.5,
          frequency: 3,
          reach: 150
        },
        gotv: {
          cpm: 10,
          ctr: 1.5,
          frequency: 3,
          reach: 150
        }
      }
    },
    beforeDestroy () {
      this.updateAdvertiser()
    },
    computed: {
      ...mapGetters({
        user: 'getCurrentUser',
        advertisers: 'getAdvertisers'
      }),
      selectedAdvertiser () {
        return this.advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
      }
    },
    methods: {
      updatePersuasionMetric (metric, value) {
        this.persuasion[metric] = value
      },
      updateGotvMetric (metric, value) {
        this.gotv[metric] = value
      },
      updateAdvertiser () {
        let advertiserCopy = lodash.cloneDeep(this.selectedAdvertiser)
        if (!advertiserCopy) return false
        advertiserCopy.data.goals = {}
        advertiserCopy.data.goals.persuasion = this.persuasion
        advertiserCopy.data.goals.gotv = this.gotv
        new Promise(resolve => {
          resolve(this.$store.dispatch('updateAdvertiser', advertiserCopy))
        })
          .catch(err => helpers.handleError(err))
      }
    },
    watch: {
      selectedAdvertiser: {
        handler (val) {
          if (val) {
            const goals = val.data.goals
            if (goals) {
              if (goals.persuasion) {
                this.persuasion = lodash.cloneDeep(goals.persuasion)
              }
              if (goals.gotv) {
                this.gotv = lodash.cloneDeep(goals.gotv)
              }
            }
          }
        },
        immediate: true
      }
    }
  }
</script>
<style scoped>
    .component-fade-enter-active, .component-fade-leave-active {
        transition: opacity .3s ease;
    }
    .component-fade-enter, .component-fade-leave-to
        /* .component-fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .switch label {
      color: white!important
    }
</style>
